import React from 'react';
import cx from 'classnames';

import { Icon, Text } from '../../../ui-kit';

import '../styles/_card-banner.scss';












export default function CardBanner(
{ cards })
{
  return (
    <ul className="card-banner">
      {cards.map(
        (
        { title, description, showBorderRight, icon: { name, size } },
        i) =>

        <li
        // eslint-disable-next-line react/no-array-index-key
        key={`card-${i}`}
        className={cx('card-banner__card', {
          'card-banner__card--border-right': showBorderRight
        })}>

            {name && <Icon name={name} size={size || 35} />}
            <Text heading5>{title}</Text>
            {description}
          </li>

      )}
    </ul>);

}

CardBanner.defaultProps = {
  cards: []
};